import { module } from 'modujs';
import { gsap } from 'gsap';
import { lerp } from '../utils/maths';

export default class extends module {
    constructor(m) {
        super(m);

        this.$slides = this.$('slide');
        this.length = this.$slides.length;
    }

    init() {

        this.swiper = new Swiper(this.el, {
            speed: 600,
            // loop: true,
            centeredSlides: true,
            shortSwipes: false,
            longSwipesRatio: 0.2,
            longSwipesMs: 100,
            touchRatio: 0.5,
            grabCursor: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            keyboard: true
            // loop: true, // <== repeat infinitely the 12 items. with fast scroll at the end of a cycle it waits a while before render the next cycle. Awful
            // loopedSlides: 2,
        });

        this.swiper.slides.forEach((slide) => {
            slide.lerpedProgress = 0;
            slide.gsap = gsap.fromTo(slide,{
                borderRadius: '30vw'
            },{
                borderRadius: '55px'
            });
            slide.gsap.pause();

        });
        
        this.lerpOffset = {
            value: 1
        };
        this.swiper.on('touchStart',(e) => {
            gsap.to(this.lerpOffset,{
                value: 1,
                duration: 0,
            });
        });

        this.swiper.on('touchEnd',(e) => {
            gsap.to(this.lerpOffset,{
                value: 0.06,
                duration: 0,
            });
        });

        this.swiper.on('slideChangeTransitionStart',(e) => {
            gsap.to(this.lerpOffset,{
                value: 0.06,
                duration: 0,
            });
        });
        this.swiper.on('slideChangeTransitionEnd',(e) => {
            gsap.to(this.lerpOffset,{
                value: 1,
                duration: 0,
            });
        });

        this.swiper.slideTo(Math.ceil(this.length/2) - 1);

        this.animate();
        // cancelAnimationFrame(this.raf);

    }

    trigger(e) {
        if(e.mode == 'enter') {
            this.animate();
        } else {
            cancelAnimationFrame(this.raf);
        }
    }

    animate() {
        this.raf = requestAnimationFrame(() => this.animate());
        
        this.swiper.slides.forEach((slide) => {
            slide.lerpedProgress = lerp(slide.lerpedProgress, slide.progress, this.lerpOffset.value);
            slide.gsap.progress(1 - Math.abs(slide.lerpedProgress));

            let rotationProgress = slide.lerpedProgress;
            let scaleProgress = Math.abs(Math.max(-1,Math.min(1,slide.lerpedProgress)))/3;
            let transitionProgress = Math.abs(slide.lerpedProgress);

            slide.style.transform = `translate3d(${-slide.lerpedProgress*2}vw,${transitionProgress * 15}vh,0) scale3d(${1-scaleProgress},${1-scaleProgress},1) rotate(${-rotationProgress * 15}deg)`;
        });
    }

    destroy() {
        cancelAnimationFrame(this.raf);

    }

}
